import styled from 'styled-components';

export const SectionLine = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;
